import { domAnimation, LazyMotion } from "framer-motion";
import React from "react";

import Header from "@/app/Views/Profile/components/Header";
import useIsLoggedIn from "../../../hooks/use-IsLoggedIn";
import EmployerFooter from "./EmployerFooter";
import HeroSection from "./components/HeroSection";
import HiringWorkflow from "./components/HiringWorkflow";
import IndustriesSection from "./components/IndustriesSection";
import PricingSection from "./components/PricingSection";
import StartHiringCTA from "./components/StartHiringCTA";

function EmployersLandingPage() {
	const isLoggedIn = useIsLoggedIn();

	return (
		<LazyMotion features={domAnimation} strict>
			<div className="min-h-screen bg-white">
				<Header isLoggedIn={isLoggedIn} variant={isLoggedIn ? "applicant" : "default"} />

				<main>
					<HeroSection />
					<IndustriesSection />
					<HiringWorkflow />
					<PricingSection />
					<StartHiringCTA />
				</main>

				<EmployerFooter variant="employer" />
			</div>
		</LazyMotion>
	);
}

export default EmployersLandingPage;
